package com.sddamico.swigmore.ds

import com.varabyte.kobweb.compose.ui.Modifier

/**
 * Swigmore Poll — typography. Display = Graduate (collegiate slab, one weight), Body/UI = Archivo,
 * Mono = JetBrains Mono (readouts, timestamps, metadata). Loaded from Google Fonts in
 * site/build.gradle.kts.
 */
object SwType {
  const val display = "'Graduate', Georgia, serif"
  const val body = "'Archivo', system-ui, -apple-system, 'Segoe UI', sans-serif"
  const val mono = "'JetBrains Mono', ui-monospace, Menlo, monospace"
}

/** Graduate at [size] (e.g. "22px", "clamp(32px,5vw,54px)"), line-height 1 by default. */
fun Modifier.typeDisplay(size: String, lineHeight: String = "1") =
  css("font" to "400 $size/$lineHeight ${SwType.display}")

/** Archivo body copy. */
fun Modifier.typeBody(size: String = "16px", weight: Int = 400, lineHeight: String = "1.55") =
  css("font" to "$weight $size/$lineHeight ${SwType.body}")

/** Archivo 800 uppercase micro label — eyebrows, column headers, caps buttons. */
fun Modifier.typeCaps(size: String = "11px", tracking: String = ".2em") = css(
  "font" to "800 $size ${SwType.body}",
  "letter-spacing" to tracking,
  "text-transform" to "uppercase",
)

/** Bold uppercase team name, as on every ranking card. */
fun Modifier.typeTeam(size: String = "16px") = css(
  "font" to "800 $size/1.15 ${SwType.body}",
  "text-transform" to "uppercase",
  "letter-spacing" to ".02em",
)

/** JetBrains Mono readout. */
fun Modifier.typeMono(size: String = "10px", weight: Int = 400, lineHeight: String = "normal") =
  css("font" to "$weight $size/$lineHeight ${SwType.mono}")
